import * as personsPicker from './components/persons-picker';
import * as datePicker from './components/date-picker';
import * as durationPicker from './components/duration-picker';
import * as geographyPicker from './components/geography-picker';
import * as sortorderPicker from './components/sortorder-picker';

personsPicker.registerComponent();
datePicker.registerComponent();
durationPicker.registerComponent();
geographyPicker.registerComponent();
sortorderPicker.registerComponent();
